import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface SubscriptionState {
  subscription: any | null;
}

const initialState: SubscriptionState = {
  subscription: null,
};

const subscriptionSlice = createSlice({
  name: "subscription",

  initialState,

  reducers: {
    setSubscription: (
      state,
      action: PayloadAction<any>,
    ) => {
      state.subscription =
        action.payload;
    },


    clearSubscription: (
      state,
    ) => {
      state.subscription = null;
    },


  },
});

export const {
  setSubscription,
  clearSubscription,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
